export const propInfo = {
  name: {
    saveSuccess: "Nazwa obiektu została zapisana",
    successTitle: "Gotowe",
    saveError: "Nie udało się zapisać nazwy obiektu",
  },
  capacity: {
    saveSuccess: "Pojemność została zapisana",
    saveError: "Nie udało się zapisać pojemności",
  },
  location: {
    loadError: "Nie udało się wczytać szczegółów oferty.",
    appliedBulk: "Lokalizacja zastosowana w powiązanych zakwaterowaniach: {count}",
    saveSuccess: "Lokalizacja została zapisana",
    partialError: "Niektórych zakwaterowań nie udało się zaktualizować",
    savePropertySuccess: "Lokalizacja obiektu została zapisana",
    saveError: "Nie udało się zapisać lokalizacji obiektu",
    loading: "Wczytywanie lokalizacji oferty…",
    noUnitsTitle: "Ta oferta nie ma jeszcze skonfigurowanych jednostek.",
    noUnitsText: "Utwórz co najmniej jedną jednostkę, aby ustawić lokalizację.",
    bulkNotice: "Ta zmiana obejmie powiązane zakwaterowania ({count}) obiektu: {name}.",
  },
  description: {
    saveSuccess: "Opis został zapisany",
    saveError: "Nie udało się zapisać opisu",
    cloneTitleNoun: "opis",
    cloneItemNoun: "opis",
  },
};
